import { render, staticRenderFns } from "./Math.vue?vue&type=template&id=6f3ad88d&scoped=true&"
import script from "./Math.vue?vue&type=script&lang=js&"
export * from "./Math.vue?vue&type=script&lang=js&"
import style0 from "./Math.vue?vue&type=style&index=0&id=6f3ad88d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ad88d",
  null
  
)

export default component.exports